import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import UserDateFormat from '../../../components/user-date-format/index';
import { messages } from '../messages';

const ShipDate = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));

  if (!fulfillment?.trackingInformation?.shipDate) {
    return '';
  }

  return <UserDateFormat value={fulfillment.trackingInformation.shipDate} />;
};

ShipDate.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const shipDate = {
  getMessageDescriptor: () => messages.shipDate,
  name: <FormattedMessage {...messages.shipDate} />,
  id: 'shipDate',
  render: (data) => <ShipDate fulfillmentId={data.id} />,
};
